import React, {useEffect, useState} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {makeStyles} from '@material-ui/core/styles';
import classnames from 'classnames';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogActions from '@material-ui/core/DialogActions';
import {ActionButton} from 'components/common';
import PMCSnackbar from "../../common/Snackbar";
import ExtRoleUpdate from "./ExtRoleUpdate";
import {CircularProgress} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    container: {
        '& .MuiDialog-paper': {
            maxHeight: 855,
            minHeight: '90%',
            maxWidth: 'unset',
            // boxShadow: theme.palette.shadow.main,
        },
        height: '100%',
    },
    actions: {
        padding: 0,
    },
    title: {
        height: 96,
        background: theme.palette.secondary.main,

        '& h2': {
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontSize: 26,
            lineHeight: '30px',
            color: theme.palette.base.white,
        },
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        margin: 0,
        paddingBottom: theme.spacing(4),

    },
    button: {
        width: 180,
        height: 40,
        marginLeft: 20,
        marginRight: 20,
        fontSize: 14,
    },
    buttonNavigation: {
        display: 'flex',
        background: theme.palette.base.white,
        height: '55px',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        bottom: 0,
        width: '50%',
        justifyContent: 'flex-end',
    },
    buttonNavigationCancel: {
        display: 'flex',
        background: theme.palette.base.white,
        height: '55px',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        bottom: 0,
        width: '50%',
        justifyContent: 'left',
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
    },
}));


function ExtRole(props) {
    const {
        userUseCases,
        useCases,
        rowClickHandel,
        headerClickHandel,
        headerChecked,
        handleClose,
        readOnly,
        saveRole,
        setIsFetchedRoles,
        roleConfigModel,
        error,
        setError,
        saving,
        setSaving,
        snackbarOpen,
        setSnackbarOpen,
        subjects,
        user
    } = props;


    const classes = useStyles();

    const {t} = useTranslation();


    const [updatedRole, setUpdatedRole] = useState();
    const [errorStep1, setErrorStep1] = useState({});

    useEffect(() => {
        if (roleConfigModel.role) {
            setUpdatedRole(roleConfigModel.role);
        }
        setErrorStep1({});
    }, [roleConfigModel]);

    const isValid = () => {
        let ret = true;
        const error = {};
        if (!updatedRole.name || updatedRole.name.trim().length === 0) {
            error.name = 'required';
            ret = false;
        }
        if (!updatedRole.active) {
            error.active = 'required';
            ret = false;
        }
        console.log('error', error);
        setErrorStep1(error);

        return ret;
    }

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbarOpen(false);
    };

    const handleChange = (name) => (event) => {
        if (event && event.target) {
            setUpdatedRole({...updatedRole, [name]: event.target.value});
        } else {
            setUpdatedRole({...updatedRole, [name]: event});
        }
    }

    return (
        <Dialog
            className={classes.container}
            open={roleConfigModel.open}
            onClose={handleClose}
        >
            <DialogTitle className={classnames(classes.title)}>
                <span>
                    {t(roleConfigModel.isNew ? 'CREATE_EXT_ROLE' : 'UPDATE_EXT_ROLE')}
                </span>
            </DialogTitle>

            <PMCSnackbar open={snackbarOpen} onClose={handleCloseSnackbar} severity={'error'} message={error}/>

            <DialogContent className={classes.content}>
                <div className={classes.container}>
                    <ExtRoleUpdate 
                        userUseCases={userUseCases}
                        useCases={useCases}
                        rowClickHandel={rowClickHandel}
                        headerClickHandel={headerClickHandel}
                        headerChecked={headerChecked}
                        handleChange={handleChange}
                        updatedRole={updatedRole}
                        error={errorStep1}
                        readOnly={readOnly}
                        subjects={subjects}
                        user={user}
                    />
                </div>
            </DialogContent>
            <DialogActions className={classes.actions}>
                <div className={classes.buttonNavigationCancel}>
                    <div className={classes.wrapper}>

                        <ActionButton
                            action="close"
                            handleClick={handleClose}
                            className={classes.button}
                        />
                    </div>

                </div>
                <div className={classes.buttonNavigation}>
                    <div className={classes.wrapper}>
                        <ActionButton
                            
                            loading={saving}
                            action="save" handleClick={() => {
                                const ret = isValid();
                                if (ret) {
                                    saveRole(updatedRole);
                                    setSaving(true);
                                }
                            }}
                            className={classes.button}
                        />
                        {saving && <CircularProgress size={24} className={classes.buttonProgress}/>}
                    </div>
                </div>
            </DialogActions>
        </Dialog>

    );
}

ExtRole.propTypes = {};

const mapStateToProps = (store) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ExtRole);


